import { defineMessages } from "react-intl";

const PREFIX = "User.UserInfo";
export default defineMessages({
  name: {
    id: `${PREFIX}.name`,
    defaultMessage: "Name",
  },
  surname: {
    id: `${PREFIX}.surname`,
    defaultMessage: "Surname",
  },
  department: {
    id: `${PREFIX}.department`,
    defaultMessage: "Department",
  },
  fieldIsRequired: {
    id: `${PREFIX}.fieldIsRequired`,
    defaultMessage: "The field is required",
  },
  checkCorrectness: {
    id: `${PREFIX}.checkCorrectness`,
    defaultMessage: "Please, check the correctness of the entered data",
  },
  addPhoto: {
    id: `${PREFIX}.addPhoto`,
    defaultMessage: "Add photo",
  },
  changePhoto: {
    id: `${PREFIX}.changePhoto`,
    defaultMessage: "Change photo",
  },
  inputFileTooltip: {
    id: `${PREFIX}.inputFileTooltip`,
    defaultMessage: "Only png, jpeg, jpg formats. File must be less than 2MB",
  },
  deletePhoto: {
    id: `${PREFIX}.deletePhoto`,
    defaultMessage: "Delete photo",
  },
  fileIsTooBig: {
    id: `${PREFIX}.fileIsTooBig`,
    defaultMessage: "The selected file cannot be uploaded. Please, load a file less than 2 MB.",
  },
});
